"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingRules = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_1 = require("react");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_dialog_delete_1 = require("@dzambalaorg/mui-dialog-delete");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const provider_user_1 = require("@dzambalaorg/provider-user");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const buttons_1 = require("../../../../../buttons");
const types_2 = require("../../../../../types");
const dialogs_1 = require("../../../../../dialogs");
const search_1 = require("./search");
const schemas_1 = require("./schemas");
const STAKING_RULES_URL = "/staking/rules";
const StakingRules = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return {
            stakingRuleStatus: [types_1.StakingRuleStatus.ACTIVE, types_1.StakingRuleStatus.NEW],
            contractIds: [],
            deposit: {
                tokenType: [],
            },
            reward: {
                tokenType: [],
            },
            ...(service === types_2.ServiceType.OFFICE && { merchantId: profile.merchantId }),
        };
    }, [service, profile]);
    const isMd = (0, material_1.useMediaQuery)(theme => theme.breakpoints.down("md"));
    const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount, refetch } = (0, react_hooks_1.useFetchQuery)(STAKING_RULES_URL, { enableInfiniteScroll: isMd }, void 0, initialSearchValues);
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const stakingRuleEdit = (rule) => () => {
        openDialog(dialogs_1.GlobalDialogKeys.STAKING_RULE_EDIT, rule, {
            refetch,
            initialValues: rule,
            message: "dialogs.edit",
            testId: "StakingDialogForm",
            url: `${STAKING_RULES_URL}/${rule.id}`,
            filter: schemas_1.stakingRulesFilter,
            prepareInitialValues: schemas_1.prepareStakingRulesInitialValues,
            componentProps: {
                readOnly: true,
                mode: "edit",
                stakingRuleStatus: rule.stakingRuleStatus,
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "staking", "staking.rules"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.staking.rules.title", children: (0, jsx_runtime_1.jsx)(buttons_1.StakingRuleCreateButton, {}) }), (0, jsx_runtime_1.jsx)(search_1.StakingRulesFromSearch, { initialSearchValues: initialSearchValues, service: service }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: allRows.length, isLoading: isLoading, children: allRows.map(rule => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: 0.4 }, children: `${rule.title} #${rule.externalId}` }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: 0.2 }, children: rule.contract.title }), (0, jsx_runtime_1.jsxs)(styled_1.ListActions, { children: [(0, jsx_runtime_1.jsx)(buttons_1.StakingToggleRuleButton, { rule: rule }), (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: stakingRuleEdit(rule), message: "form.buttons.edit", dataTestId: "RuleEditButton", icon: icons_material_1.Create })] })] }, rule.id))) }) }), !isMd && totalCount > take && ((0, jsx_runtime_1.jsx)(styled_1.StyledPagination, { shape: "rounded", page: skip / take + 1, count: Math.ceil(totalCount / take), onChange: onChangePage })), isMd && hasNextPage && (0, jsx_runtime_1.jsx)("div", { ref: loadMoreRef, style: { height: "20px", margin: "20px 0" } }), (0, jsx_runtime_1.jsx)(mui_dialog_delete_1.DeleteDialog, { url: STAKING_RULES_URL, refetch: refetch })] }));
};
exports.StakingRules = StakingRules;
//# sourceMappingURL=index.js.map